import React from 'react';
import { Badge, Button, Card, Collapse, ListGroup } from 'react-bootstrap';
import { ImSpinner10 } from 'react-icons/im';
import { useAppContext } from '../../App';





export default function ClueSuggestionCard({ displayWord, isComplete, isFocused, isLoading, clueSuggestionObj, setPlaceholderText, setClueText, showBody, setShowBody }) {

  const { isAuthenticated } = useAppContext();



  return (
    <Card>
      <Card.Header className='px-2 py-1 d-flex clickable' onClick={() => setShowBody(!showBody)}>
        <span className='small my-auto'><strong>{displayWord}</strong> in crosswords</span>
        <Button
          className='ms-auto py-0'
          size='sm'
          variant='link'
          onClick={() => setShowBody(!showBody)}
        >{showBody ? 'hide' : 'show'}</Button>
      </Card.Header>

      <Collapse in={showBody}>
        <div id='clue-suggestion-card-body'>
          <Card.Body>
            {!isComplete ? (
              <div className='fst-italic small'>Incomplete word</div>
            ) : !isAuthenticated ? (
              <div className='small'>Log in to see word definitions, common usage in crosswords, and clue suggestions.</div>
            ) : !isFocused ? (
              // Text input has not yet been focused (still focused on grid)
              <div className='small'>Click into the clue to see details on this word.</div>
            ) : isLoading ? (
              // Word is complete, but clue suggestion not available yet: still loading
              <div className='small'><ImSpinner10 className='spinning me-3' />Loading...</div>
            ) : !clueSuggestionObj ? (
              // Some other unknown
              <div className='small'>Oops! We weren't able to suggest clues.</div>
            ) : (
              <>
                {/* <div className='d-flex mb-2'>
                  <div className='mb-auto' style={{ minWidth: '120px' }}><Badge bg='secondary'>Interpretation</Badge></div>
                  <span className='small'>{clueSuggestionObj?.type}</span>
                </div> */}

                {clueSuggestionObj?.notes && (
                  <div className='d-flex mb-2'>
                    <div className='mb-auto me-3'><Badge bg='info'>About</Badge></div>
                    <span className='small'>{clueSuggestionObj?.notes}</span>
                  </div>
                )}

                <div className='small'>
                  <div className="mb-1 fw-bold">Some clue starters:</div>
                  <ListGroup variant="flush">
                    {clueSuggestionObj?.clueOptions.map((clueOption, idx) => (
                      <ListGroup.Item
                        className={'px-1 py-0 clickable shade-on-hover'}
                        style={{ borderRadius: '3px' }}
                        key={idx}
                        onMouseEnter={() => {
                          setPlaceholderText(clueOption);
                        }}
                        onClick={e => {
                          setClueText(clueOption);
                        }}
                      >
                        <div>{clueOption}</div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              </>
            )}
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
}